import Alert from '@mui/material/Alert';
import { ANALYST_PRIMARY_STEP_KEYS } from '../constants';
import { MilestonesSection, WorkProgressSection } from '../sections';

const STEP_COMPONENT_MAP = {
  [ANALYST_PRIMARY_STEP_KEYS.JOB_INFORMATION]: ComingSoonAlert,
  [ANALYST_PRIMARY_STEP_KEYS.MILESTONES]: MilestonesSection,
  [ANALYST_PRIMARY_STEP_KEYS.WORK_PROGRESS]: WorkProgressSection,
  [ANALYST_PRIMARY_STEP_KEYS.COMPLETED]: ComingSoonAlert,
};

function ComingSoonAlert() {
  return <Alert severity='info'>Coming Soon</Alert>;
}

function NotFoundAlert() {
  return <Alert severity='error'>Not Found</Alert>;
}
/**
 * AnalystPrimaryContent component
 * @param {Object} props
 * @param {Object} props.data
 * @param {Array} props.steps
 * @param {number} props.activeStep
 * @returns {JSX.Element}
 */
export default function AnalystPrimaryContent({ data, steps, activeStep }) {
  const stepKey = steps[activeStep]?.key;
  const StepComponent = STEP_COMPONENT_MAP[stepKey] || NotFoundAlert;

  return <StepComponent data={data} />;
}
